import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  setAuthModalContent,
  setShowAuthModal,
  setShowEnableMediumAuthBtn,
  setShowGetKuwaitAppBtn,
} from '../../reducer/utilitySlice';
import { redirecturl } from '../../services/common/redirect';
import {
  getGlobalSettingValue,
  getItemOfSessionStorage,
} from '../../services/common/utils';
import { setClickedTrasferPointsCardData } from '../../reducer/nojoomSlice';
import { IS_2FA_DONE } from '../../services/common/Constants';
import { useTranslation } from 'react-i18next';
import { GTM_Select_Item } from "../../../src/analytics/GoogleTagManager";
import ExclusiveModal from "../../components/common/exclusive-modal"
import { useEffect, useState } from 'react';
const TransferPointsCard = ({ data }) => {
  const navigate = useNavigate();
  const {
    utilityData: { globalSetting },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const[crrdata,setcrrdata] = useState();
  const [show, setShow] = useState(false);
  const [deeplinktext, setDeeplinktext] = useState("");
  const { t } = useTranslation();
  // console.log(data?.redirecturl, "datasee")
  const settingsArr = globalSetting
  ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
  : [];

  const toggleModal = () => {
    setShow(!show);
  };

  useEffect(()=>{
    let crrdata = {
       category: data?.displaytext,
       category_ar: data?.displaytext_ar,
       redirecturl: data?.redirecturl
     }
     try{
     for (const key in data?.metadata) {
       console.log(`${key}: ${data?.metadata[key]}`);
 
        if(data?.metadata[key]?.meta_key == "id")
        crrdata.id = data?.metadata[key]?.meta_value_english
        
        if(data?.metadata[key]?.meta_key == "infotype")
        crrdata.infotype = data?.metadata[key]?.meta_value_english
 
        if(data?.metadata[key]?.meta_key == "previewimage_web")
        crrdata.previewimage = data?.metadata[key]?.meta_value_english
 
        if(data?.metadata[key]?.meta_key == "infotype")
        crrdata.membershipid = data?.metadata[key]?.meta_value_english
   }
 }catch{}
    
   setcrrdata(crrdata);
    
   },[])
  const handleRedirect = (e, url) => {
    e.preventDefault();
    navigate(`/${data?.redirecturl}`, { state: crrdata })
  };

  const handleTransferCard = (e, url) => {
    try{
      const temp = {
        category: data?.metadata?.find((item) => item?.meta_key === "category")["meta_value_english"],
        id: data?.metadata?.find((item) => item?.meta_key === "id")["meta_value_english"]
      }
      GTM_Select_Item(data, "TransferPoints")
    }catch{}


    try{
      if(data?.metadata != null && data?.metadata != undefined && data?.metadata != ""
      && data?.metadata?.length > 0){
      for (var i = 0; i < data?.metadata?.length; i++) {
        if (data?.metadata[i]?.meta_key == "web_deeplink") {
          let deeplink = data?.metadata[i]?.meta_value_english;
          setShow(true);
          setDeeplinktext(deeplink);
          return false;
        }
        if (data?.metadata[i]?.meta_key == "web_notallowed") {
          //need to show popup for only app feature
          // console.log("exclusive feature for app");
          setShow(true);
          return false;
        }
      }
    }
    }catch{}

    if (getItemOfSessionStorage(IS_2FA_DONE) === 'true') {
      handleRedirect(e, url);
    } else {
      dispatch(setShowEnableMediumAuthBtn(false));
      dispatch(setShowGetKuwaitAppBtn(false));
      //dispatch(setClickedTrasferPointsCardData(data));
      dispatch(setClickedTrasferPointsCardData(crrdata));
      dispatch(setShowAuthModal(true));

      dispatch(
        setAuthModalContent({
          icon: getGlobalSettingValue('beforeverificationicon_web', settingsArr),
          title: getGlobalSettingValue('beforeverificationtitle', settingsArr),
          message: getGlobalSettingValue('beforeverificationmsg', settingsArr),
          btnText: getGlobalSettingValue(
            'beforeverificationbuttontext',
            settingsArr
          ),
        })
      );
    }
    try{
      GTM_Select_Item(data, "NojoomPartner")
    }catch{}
  };

  return (
    <>
      <Link
        className="card_style_1 height_100"
        to="#"
        onClick={(e) => handleTransferCard(e, data?.redirecturl)}
      >
        <div className="card_img">
          <img
            src={
              data?.imageurl ||
              process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
            }
            alt=""
            title=""
          />
        </div>
        <div className="card_info text-center">
          <div className="card_info_grp">
            <h4 className="text-ellipsis">{data?.displaytext}</h4>
            <p>{data?.description}</p>
          </div>
          <div className="card_link">
            <Link
              to="#"
              className="hyperlink"
              //onClick={(e) => handleTransferCard(e, data?.redirecturl)}
            >
              {data?.buttontext}
              <img
                src={
                  process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
                }
                alt=""
                title=""
              />
            </Link>
          </div>
        </div>
      </Link>


      <ExclusiveModal
            show={show}
            toggleModal={toggleModal}
            deeplinktext={deeplinktext}
          />

    </>
  );
};
export default TransferPointsCard;
